import { formatLabelValue } from 'app/admin/whatIf/component/WhatIfUtil';

export default function (props) {
	const { value } = props;
	return <span title={value}>{formatLabelValue(value, props)}</span>;
}
